// extracted by mini-css-extract-plugin
export default {"wrapper":"u4CP2","title":"FrrmI","sub-title":"drG4l","subTitle":"drG4l"};